export function fetchApplications(BeURL, showAlert, setSavedIds, setAppliedIds) {
    fetch(`${BeURL}/my-applications`, { credentials: 'include' })
    .then(r => r.json())
    .then(({ savedList, appliedList, success, message, popup }) => {
        if (success) {
            setSavedIds(savedList);
            setAppliedIds(appliedList);
        } else {
            if (popup !== false) showAlert(message);
            console.log("my application api : " , message)
        }
    })
    .catch(err => {
        console.log("Error in fetching my applications:",err)
        showAlert('Failed to load your applications.')
    });
}

export function applyJob(BeURL, showAlert, id, setApplyLoader, setAppliedIds , status) {
    if (["apply"].includes(status)) {
        setApplyLoader({ id: id, status: true })
    }
    fetch(`${BeURL}/apply-job`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ jobId: id })
    })
        .then(r => r.json())
        .then(({ success, message }) => {
            if (["apply"].includes(status)) {
                setApplyLoader({ id: "", status: false });
                if (success) {
                    setAppliedIds(a => [...a, id]);
                }
                showAlert(message);
            }
            if (success) {
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            }
            showAlert(message);
        })
    .catch(err => {
        console.log("Error in appling for Jobs:",err)
        if (["apply"].includes(status)) {
            setApplyLoader({ id: "", status: false })
        }        
        showAlert('Unable to apply.')
    });
}

export function toggleJobSave(BeURL, showAlert, id, isSaving, page, setSaveLoader, setSavedIds, status) {
    if (["save"].includes(status)) {
        page === "dashboard" && setSaveLoader({ id: id, status: true })
    }
    if (isSaving){
        fetch(`${BeURL}/toggle-save`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ jobId: id })
        })
        .then(r => r.json())
        .then(({ savedList, success, message }) => {
            if (["save"].includes(status)) {
                page === "dashboard" && setSaveLoader({ id: "", status: false })
                if (success || page === "dashboard") setSavedIds(savedList);
                showAlert(message);
            }
            if (success) {
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            }
            showAlert(message);
        })
        .catch(err => {
            console.log("Error in Saving Job:",err)
            if (["save"].includes(status)) {
                page === "dashboard" && setSaveLoader({ id: "", status: false })
            }
            showAlert('Unable to update save status.')
        });
    }
    else {
        fetch(`${BeURL}/remove-saved-job/${id}`, {
            credentials: 'include'
        })
        .then(res => res.json())
        .then(data => {
            page === "dashboard" && setSaveLoader({ id: "", status: false })
            showAlert(data.message);
            if (data.success && page === "dashboard") window.location.reload();
        })
        .catch(err => {
            page === "dashboard" && setSaveLoader({ id: "", status: false })
            console.error('Error un-saving:', err);
            showAlert('Unable to un-save job.');
        });
    }
}